<div class="filter-container um-toolbar form-inline">
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field time-range-select">
      <mat-label>Time Range</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="timeRange" (selectionChange)="onTimeRangeChange()">
        <mat-option value="day">Day</mat-option>
        <mat-option value="week">Week</mat-option>
        <mat-option value="month">Month</mat-option>
        <mat-option value="custom">Custom</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Source</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="source" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="android">Android</mat-option>
        <mat-option value="ios">iOS</mat-option>
        <mat-option value="mobile">Mobile</mat-option>
        <mat-option value="web">Web</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field appearance="fill" style="margin-left: 5px;" class="form-field">
        <mat-label>Active</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="userState" (selectionChange)="onTimeRangeChange()">
          <mat-option value="">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
    </mat-form-field> -->

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Type</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="userType" (selectionChange)="onTimeRangeChange()">
          <mat-option value="">All</mat-option>
          <mat-option value="Administrator">Admin</mat-option>
          <mat-option value="Customer">Customer</mat-option>
          <mat-option value="US Admin">US Admin</mat-option>
          <mat-option value="Sales Rep">Sales Rep</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Users</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="pvUser" (selectionChange)="applySearchFilter()">
          <mat-option value="">All</mat-option>
          <mat-option value="true">PV</mat-option>
          <mat-option value="false">Non-PV</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Page</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="pageType" (selectionChange)="applySearchFilter()">
          <mat-option value="">All</mat-option>
          <mat-option value="Footage">Footage</mat-option>
          <mat-option value="Live Views">Live Views</mat-option>
          <mat-option value="NVR NAS">NAS</mat-option>
          <mat-option value="Arm/Disarm">Arm/Disarm</mat-option>
          <mat-option value="News Letter">News Letter</mat-option>
          <mat-option value="Consolidated Email">Consolidated Email</mat-option>
          <mat-option value="Crime Prevention">Crime Prevention</mat-option>
          <mat-option value="LPR">LPR</mat-option>
          <mat-option value="Timelapse">Timelapse</mat-option>
          <mat-option value="Footage Downloads">Footage Downloads</mat-option>
          <mat-option value="Help Widget">Help Widget</mat-option>
          <mat-option value="SAML Login">SAML Login</mat-option>
          <mat-option value="User Not Found">User Not Found</mat-option>
          <mat-option value="Incorrect Creds">Incorrect Creds</mat-option>
          <mat-option value="No Sites Added">No Sites Added</mat-option>
          <!-- <mat-option value="No Sites Added">No Sites Added</mat-option> -->
          <mat-option value="Version Update">Version Update</mat-option>
          <mat-option value="NVR NAS">NAS</mat-option>
          <mat-option value="Error">Error</mat-option>
          <mat-option value="Site Activity">Site Activity</mat-option>
          <mat-option value="Video Codec Transcode Activity">Video Codec Transcode Activity</mat-option>
          <mat-option value="PSA">PSA</mat-option>
          <mat-option value="Footage timeline">Footage timeline</mat-option>
          <mat-option value="Pre-Installation">Pre-Installation</mat-option>
          <mat-option value="Post-Installation">Post-Installation</mat-option>
          <mat-option value="Pre-Installation Mail">Pre-Installation Mail</mat-option>
          <mat-option value="Post-Installation Mail">Post-Installation Mail</mat-option>
          <mat-option value="Monitoring Contact Update">Monitoring Contacts Update</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Sub Type</mat-label>
      <mat-select *ngIf="pageType === 'Live Views'" [(value)]="subPageType" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="HD View Success">HD View Success</mat-option>
        <mat-option value="Failed HD">HD Failed</mat-option>
        <mat-option value="Visit">HD Visit</mat-option>
        <mat-option value="HD View">HD View Open</mat-option>
        <mat-option value="HD View Closed">HD View Closed</mat-option>
        <mat-option value="Continue">HD View Continue</mat-option>
        <mat-option value="SDImage">SD Snap</mat-option>
        <mat-option value="SD View">SD View</mat-option>
        <mat-option value="SD View Closed">SD View Closed</mat-option>
        <mat-option value="Snapshot Captured">Snapshot Captured</mat-option>
        <mat-option value="2 Min Recording Started">2 Min Recording Started</mat-option>
        <mat-option value="2 Min Recording Saved">2 Min Recording Saved</mat-option>
        <mat-option value="PTZ Enabled">PTZ Enabled</mat-option>
        <mat-option value="PTZ Disabled">PTZ Disabled</mat-option>
      </mat-select>
      <mat-select panelClass="um-select-panel" *ngIf="pageType !== 'Footage timeline' && pageType !== 'Live Views'" [(value)]="subPageType" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="HD View Success">HD View Success</mat-option>
        <mat-option value="Failed HD">HD Failed</mat-option>
        <mat-option value="Visit">HD Visit</mat-option>
        <mat-option value="HD View">HD View Open</mat-option>
        <mat-option value="HD View Closed">HD View Closed</mat-option>
        <mat-option value="Continue">HD View Continue</mat-option>
        <mat-option value="SDImage">SD Snap</mat-option>
        <mat-option value="SD View">SD View</mat-option>
        <mat-option value="SD View Closed">SD View Closed</mat-option>
        <mat-option value="Snapshot Captured">Snapshot Captured</mat-option>
        <mat-option value="2 Min Recording Started">2 Min Recording Started</mat-option>
        <mat-option value="2 Min Recording Saved">2 Min Recording Saved</mat-option>
        <mat-option value="PTZ Enabled">PTZ Enabled</mat-option>
        <mat-option value="PTZ Disabled">PTZ Disabled</mat-option>
        <mat-option value="Site Activity Clicks">Site Activity Clicks</mat-option>
        <mat-option value="Site Activity Views">Site Activity Views</mat-option>
        <mat-option value="Crime Prevention Clicks">Crime Prevention Clicks</mat-option>
        <mat-option value="Crime Prevention Views">Crime Prevention Views</mat-option>
        <mat-option value="Crime Prevention">NL - CP</mat-option>
        <mat-option value="Site Activity">NL Activity</mat-option>
        <mat-option value="Monitoring Event Log">Monitoring Event Log</mat-option>
        <mat-option value="Multi-Site Site Activity">Multi-Site Site Activity</mat-option>
      </mat-select>
      <mat-select panelClass="um-select-panel" *ngIf="pageType === 'Footage timeline'" [(value)]="subPageType" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="ZoomIn">ZoomIn</mat-option>
        <mat-option value="ZoomOut">ZoomOut</mat-option>
        <mat-option value="Download">Download</mat-option>
        <mat-option value="Event selected">Event selected</mat-option>
        <mat-option value="Views the events">Views the events</mat-option>
        <mat-option value="Error">Error</mat-option>
      </mat-select>
  </mat-form-field>
    <!-- <mat-form-field appearance="fill" style="margin-left: 5px;" class="form-field">
      <mat-label>Active</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="userState" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="Active">Yes</mat-option>
        <mat-option value="User Logout">Logout</mat-option>
        <mat-option value="System Logout">System Logout</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Keep Login</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="keepLogin" (selectionChange)="applySearchFilter()">
          <mat-option value="">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
    </mat-form-field> -->

    <mat-form-field appearance="fill" floatLabel="always" class="form-field search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchKeyword" (keyup.enter)="applySearchFilter()" #searchInput [disabled]="isLoading">
        <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="applySearchFilter()" (mousedown)="$event.preventDefault()" type="button" tabindex="-1" [disabled]="isLoading">
            <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button matSuffix class="suffix-icon-btn" [class.search-clear-btn--hidden]="!searchKeyword" (click)="clearSearch()" (mousedown)="$event.preventDefault()" type="button" tabindex="-1" [disabled]="isLoading">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-form-field>
  
    <div class="toolbar-actions">
      <button mat-icon-button (click)="downloadCSV()" matTooltip="Download CSV" aria-label="Download CSV" class="toolbar-icon-btn download-button">
        <mat-icon>download</mat-icon>
      </button>
    </div>

    <div *ngIf="timeRange === 'custom'" class="custom-date-picker">
      <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field custom-date-field">
        <input matInput [owlDateTime]="startPicker" [owlDateTimeTrigger]="startPicker" placeholder="Start Date" [(ngModel)]="startDate" (dateTimeChange)="onCustomDateChange()">
        <!-- <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker> -->
        <mat-datepicker-toggle matSuffix [for]="$any(startPicker)"></mat-datepicker-toggle>
        <owl-date-time #startPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
      </mat-form-field>
      <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field custom-date-field">
        <input matInput [owlDateTime]="endPicker" [owlDateTimeTrigger]="endPicker"  placeholder="End Date" [(ngModel)]="endDate" (dateTimeChange)="onCustomDateChange()">
        <!-- <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker> -->
        <mat-datepicker-toggle matSuffix [for]="$any(endPicker)"></mat-datepicker-toggle>
        <owl-date-time #endPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
      </mat-form-field>
    </div>
</div>
<div class="table-container um-table-wrap" style="margin-bottom: 20px; position: relative;">
    <!-- Loading Overlay -->
    <div *ngIf="isLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.8); z-index: 1000; display: flex; align-items: center; justify-content: center;">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-table um-table um-table-activity">
      
      <!-- Define Columns -->
      <ng-container matColumnDef="sessionId">
        <th mat-header-cell *matHeaderCellDef>Session ID</th>
        <td mat-cell *matCellDef="let element">{{element.sessionId}}</td>
      </ng-container>
      <ng-container matColumnDef="username">
        <th class="col-username left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td class="col-username left-sorted-header" mat-cell *matCellDef="let element">{{element.username}}</td>
      </ng-container>
      <ng-container matColumnDef="source">
        <th class="col-narrow centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
        <td class="col-narrow centered-sorted-header" mat-cell *matCellDef="let element">{{element.source}}</td>
      </ng-container>
      <ng-container matColumnDef="userType">
        <th class="col-type left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>User Type</th>
        <td class="col-type left-sorted-header" mat-cell *matCellDef="let element">{{element.userType}}</td>
      </ng-container>

      <ng-container matColumnDef="loginTimeInIST">
        <th class="col-date left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header start="desc">Visit Time(IST)</th>
        <td class="col-date left-sorted-header" mat-cell *matCellDef="let element">
          <div class="dt-stack" *ngIf="element.timeStampInIST; else dashDt">
            <span class="dt-date">{{ element.timeStampInIST | dateFormat:'date' }}</span>
            <span class="dt-time">{{ element.timeStampInIST | dateFormat:'time' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="loginTimeInCT">
        <th class="col-date left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header start="desc">Visit Time(CT)</th>
        <td class="col-date left-sorted-header" mat-cell *matCellDef="let element">
          <div class="dt-stack" *ngIf="element.timeStampInCT; else dashDt">
            <span class="dt-date">{{ element.timeStampInCT | dateFormat:'date' }}</span>
            <span class="dt-time">{{ element.timeStampInCT | dateFormat:'time' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="pageType">
        <th class="col-page left-sorted-header" mat-header-cell *matHeaderCellDef>Page Type</th>
        <td class="col-page left-sorted-header" mat-cell *matCellDef="let element">{{ element?.pageType }}</td>
      </ng-container>
  
      <ng-container matColumnDef="subType">
        <th class="col-subtype left-sorted-header" mat-header-cell *matHeaderCellDef>Sub Type</th>
        <td class="col-subtype left-sorted-header" mat-cell *matCellDef="let element">{{ element?.subType }}</td>
      </ng-container>
      <ng-container matColumnDef="siteName">
        <th class="col-site left-sorted-header" mat-header-cell *matHeaderCellDef>Site Name</th>
        <td class="col-site left-sorted-header" mat-cell *matCellDef="let element">{{element?.siteName}}</td>
      </ng-container>

      <ng-container matColumnDef="potentialId">
        <th class="col-id centered-sorted-header" mat-header-cell *matHeaderCellDef>Potential Id</th>
        <td class="col-id centered-sorted-header" mat-cell *matCellDef="let element">{{ element?.potentialId }}</td>
      </ng-container>

      <ng-container matColumnDef="addInfo">
        <th class="col-actions centered-sorted-header" mat-header-cell *matHeaderCellDef>Additional Info</th>
        <td class="col-actions centered-sorted-header" mat-cell *matCellDef="let element">
            <!-- {{ getMoreInfo(element) }} -->
            <div class="table-action-btn">
              <button mat-icon-button class="custom-icon-button circle-icon-btn" (click)="openPageDialog(element)">
                  <mat-icon>info</mat-icon>
              </button>
              <button mat-icon-button class="custom-icon-button circle-icon-btn" style="margin-left: 4px;" (click)="openDialog(element)">
                <mat-icon>read_more</mat-icon>
              </button>
            </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <ng-template #dashDt>-</ng-template>

      <!-- <mat-paginator fixed 
        [pageSizeOptions]="[5, 10, 25, 100]" 
        [pageSize]="pageSize" 
        [length]="totalRecords"
        [pageIndex]="pageIndex" 
        (page)="changePaging($event)" aria-label="Select page of users">
      </mat-paginator> -->

      <!-- <mat-paginator [pageSizeOptions]="[5, 25, 50, 100]" showFirstLastButtons></mat-paginator> -->
    </table>
    <!-- <mat-paginator [length]="filteredData.length"
        [pageSize]="pageSize"
        [pageSizeOptions]="[8, 25, 50, 100]"
        [pageIndex]="pageIndex"
        showFirstLastButtons
        (page)="onPageChange($event)">
    </mat-paginator> -->
    <mat-paginator
        class="um-paginator"
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageSizeOptions]="[8, 25, 50, 100]"
        [pageIndex]="pageIndex"
        showFirstLastButtons
        (page)="onPageChange($event)">
    </mat-paginator>
</div>
  